var api = require("!../node_modules/_style-loader@1.3.0@style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../node_modules/_css-loader@3.6.0@css-loader/dist/cjs.js??ref--12-1!../node_modules/_postcss-loader@3.0.0@postcss-loader/src/index.js??postcss!./privacy.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};